import * as React from 'react'

import { CORAL_REEFS, FOOTBALL_PLAYERS, TOOL_EVIDENCE_BORDERED, WORLD_MAP } from '../asset_constants'

const WritingToLearn = ({ slideGroupClassName, }) => {
  return (
    <section className={`slide ${slideGroupClassName} writing-to-learn-slide`} key="writing-to-learn-slide">
      <h1>Writing to Learn</h1>
      <p>Quill helps students write to learn through cross-curricular nonfiction texts paired with targeted writing prompts.</p>
      <span className="divider" />
      <p className="evidence-paragraph">
        <img alt="" src={TOOL_EVIDENCE_BORDERED} />
        <span><b className="quill-teal">Quill Reading for Evidence</b> teaches students to analyze texts, identify claims, and support ideas with evidence. </span>
      </p>
      <p>Topics covered include:</p>
      <ul>
        <li>
          <div className="img-wrapper"><img alt="" src={FOOTBALL_PLAYERS} /></div>
          <div className="copy">
            <p><b>Culture & Society:</b><br /><span>ELA</span></p>
            <p className="activity-name">“Should Schools Have Grade Requirements for Student Athletes?”</p>
          </div>
        </li>
        <li>
          <div className="img-wrapper"><img alt="" src={CORAL_REEFS} /></div>
          <div className="copy">
            <p><b>Interdisciplinary Science:</b><br /><span>AI Knowledge</span></p>
            <p className="activity-name">“How Are Marine Biologists Using Machine Learning to Protect Coral Reefs?”</p>
          </div>
        </li>
        <li>
          <div className="img-wrapper"><img alt="" src={WORLD_MAP} /></div>
          <div className="copy">
            <p><b>Social Studies:</b><br /><span>World History</span></p>
            <p className="activity-name">“How Did British Women Workers Fight for Their Rights in the 19th Century?”</p>
          </div>
        </li>
      </ul>
    </section>
  )
}

export default WritingToLearn
